import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './InfoPage.css';

const InfoPage = ({ title, subtitle, content }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="info-page-boutique">
      <section className="info-hero">
        <div className="container">
          <motion.div 
            className="info-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="premium-accent-tag">Information</span>
            <h1 className="info-title">{title}</h1>
            <p className="info-subtitle">{subtitle}</p>
          </motion.div>
        </div>
        <div className="info-hero-deco" />
      </section>

      <section className="info-body">
        <div className="container">
          <motion.div 
            className="info-content-card"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="info-text-rich" dangerouslySetInnerHTML={{ __html: content }} />
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default InfoPage;
